import { ComponentProps, ReactNode } from 'react';
import Typography from '@alltrails/core/components/Typography';
import Link from '@alltrails/denali/components/Link';
import { FormattedMessage } from 'react-intl';
import Button from '@alltrails/denali/components/Button';
import type DeeplinkData from '@alltrails/types/DeeplinkData';
import CarouselDisplayTrigger from '@alltrails/amplitude/enums/CarouselDisplayTrigger';
import AppPromotion from '@alltrails/install-prompt/components/AppPromotion';
import AltLoginsForm from '../AltLoginsForm';
import SectionDivider from '../SectionDivider';
import TermsOfService from '../TermsOfService';
import signupModalStyles from './SignUpModal.module.scss';
import ContinueInAppButton from './ContinueInAppButton';
import styles from './InitialTreatment.module.scss';

type InitialProps = Pick<ComponentProps<typeof AltLoginsForm>, 'appleLoginHandler' | 'facebookLoginHandler' | 'googleLoginHandler'> & {
  heading?: ReactNode;
  onContinueWithEmailClick: () => void;
  onLogInClick: () => void;
  deeplinkData?: DeeplinkData;
  displayTrigger: CarouselDisplayTrigger;
};

// https://www.figma.com/design/wSAbhQvyqMqrzXqrFd6Ylf/Onboarding-2025-Web--Working-?node-id=8181-291667&m=dev
export default function InitialTreatment({
  heading,
  onContinueWithEmailClick,
  onLogInClick,
  deeplinkData,
  displayTrigger,
  ...loginHandlers
}: InitialProps) {
  return (
    <div className={styles.content}>
      <AppPromotion heading={heading} />
      <div>
        <ContinueInAppButton flatColors deeplinkData={deeplinkData} displayTrigger={displayTrigger} />
        <SectionDivider classes={signupModalStyles.divider}>
          <FormattedMessage defaultMessage="or" />
        </SectionDivider>
        <AltLoginsForm {...loginHandlers} authType="signup" flatColors />
        <Button
          className={signupModalStyles.email}
          onClick={onContinueWithEmailClick}
          text={<FormattedMessage defaultMessage="Continue with email" />}
          testId="continue-with-email"
          width="full"
        />
      </div>
      <div className={styles.already}>
        <div>
          <Typography className={signupModalStyles.inline} color="secondary" component="div" variant="text200">
            <FormattedMessage defaultMessage="Already have an account?" />{' '}
          </Typography>
          <Link size="md" testId="sign-up-log-in-nav" onClick={onLogInClick}>
            <FormattedMessage defaultMessage="Log in" />
          </Link>
        </div>
        <TermsOfService />
      </div>
    </div>
  );
}
